export default function Card({ children, title }: { children: JSX.Element; title: string }) {
  return (
    <div className="bg-grayish p-4 rounded-xl my-4 max-w-screen-sm w-full overflow-hidden">
      <h3>{title}</h3>
      {children}
    </div>
  );
}
